<template>
<v-hover
        v-slot:default="{ hover }"
      >
  <v-card :elevation="hover ? 4 : 2" v-if="topic">
    <v-card-title @click="viewDetail = !viewDetail">
      {{topic.name}} ({{topicMaterials.length}} Materials)
      <v-spacer/>
      <v-btn icon v-if="!viewDetail">
        <v-icon>mdi-chevron-down</v-icon>
      </v-btn>
      <v-btn icon v-if="viewDetail">
        <v-icon>mdi-chevron-up</v-icon>
      </v-btn>
    </v-card-title>
    <v-card-subtitle>
      <div class="mb-2" v-if="topic.description">
        {{topic.description}}
      </div>
      <v-dialog width="600" bottom v-for="(std) in standards" 
        :key="std.id || null">
        <template v-slot:activator="{ on, attrs }">
      <v-chip
        v-bind="attrs"
        v-on="on"
        class="mr-2"
        outlined
      >{{std.standardId || std.standardCode || 'N/A'}}</v-chip>
        </template>
        <v-card>
          <v-card-title>{{std.standardCode}}</v-card-title>
          <v-card-subtitle>{{std.categoryName}} - {{std.subCategory}}</v-card-subtitle>
          <v-card-text>{{std.standardDescription}}</v-card-text>
        </v-card>
      </v-dialog>
      
    </v-card-subtitle>
    <v-card-text v-if="viewDetail">
      <v-row dense>
        <v-col
          v-for=" (m) in topicMaterials" :key="m.id"
          cols="12"
          lg="4"
          md="6"
        >
      <v-card >
        <v-card-text>
          <v-btn @click="unlinkTopicMaterial(topic, m.materials)" class="mr-5" icon>
            <v-icon>mdi-link-variant-remove</v-icon>
          </v-btn>

          <span v-if="!m.materials.s3Url">{{m.materials.name}}</span>
          <preview-pdf v-if="m.materials.s3Url" :materialId="m.materials.id" :s3Path="m.materials.s3Url || ''" :fileName="m.materials.name"/>
        </v-card-text>
      </v-card>
        </v-col>
      </v-row>
    </v-card-text>
    <v-card-actions v-if="showActions && viewDetail">
      <v-btn icon>
        <v-icon @click="deleteTopic">mdi-delete-outline</v-icon>
      </v-btn>
      <edit-course-topic @updated="updatedTopic" :courseId="course.id" :topic="topic" />
      <standard-search
        @addedStandards="addStandards"
        :key="course.grade+'_'+course.subject"
        :grade="course.grade"
        :subject="course.subject"
        :searchTerms="topic.name"
      />
      <choose-resource
        v-if="courseMaterials"
        @selectedFile="linkTopicMaterial"
        domain="course"
        :multiple="true"
        :materials="courseMaterials"
        :topicsMaterials="courseTopicsMaterials"
        :course="course"
        activatorIcon="mdi-folder-open-outline"
      />
      <upload-files @uploaded="uploadedMaterials" :course="course" target="course"/>
      <v-spacer />
      
    </v-card-actions>
  </v-card>
</v-hover>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

const StandardSearch = () => import("@/components/standards/StandardSearch.vue");
const ChooseResource = () => import("@/components/resourceMgt/ChooseResource.vue");
const EditCourseTopic = () => import("@/components/course/EditCourseTopic.vue");
const UploadFiles = () => import("@/components/resourceMgt/UploadFiles.vue");
import Qs from "qs";
const PreviewPdf = () => import("@/components/resourceMgt/PreviewPdf.vue");


export default {
  props: {
    courseTopic: {
      type: Object,
      required: true
    },
    courseMaterials: {
      type: Array,
      required: false
    },
    course: {
      type: Object,
      required: true
    },
    showActions: {
      type: Boolean,
      required: false,
      default: true
    },
    expandMaterials: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      standards: [],
      topicMaterials: [],
      viewDetail: this.expandMaterials,
      hover: true
    };
  },
  components: { StandardSearch, ChooseResource, EditCourseTopic, PreviewPdf, UploadFiles },
  computed: {
    ...mapGetters(["navState", "isAppLoading"]),
    topic() {
      return this.courseTopic.topic;
    },
    courseTopicsMaterials(){
      if(!this.course){
        return [];
      }

      const courseTopics = this.course.courseTopics;
      if(courseTopics && courseTopics.length > 0){
        return courseTopics.map( ct => { return {id: ct.topic.id, name: ct.topic.name, materials: ct.topic['topic_topicMaterials'] || [] } })
      }
      else{
        return [];
      }
    }
  },
  mounted() {
    this.initStandards();
    this.initMaterials();
  },
  methods: {
    ...mapActions(["addErrorMessage", "addMessage"]),
    deleteTopic() {
      if (confirm("Confirm delete?")) {
        const params = {
          courseTopicId: this.courseTopic.id
        };
        const data = null;
        this.$axios
          .post("/course/topic/deleteTopic", data, { params })
          .then(() => {
            this.$emit("deleted", this.courseTopic);
          })
          .catch(error => {
            this.addErrorMessage(error.message);
          });
      }
    },
    addStandards(event, ccStandards) {

      console.log(ccStandards);

      const ccStandardIds = ccStandards.map(r => r.id);
      const data = { ccStandardIds };
      this.$axios
        .put(`/ccStandard/courseTopic/${this.courseTopic.topic.id}`, data)
        .then(resp => {
          console.log(`saved cc standards`);
          console.log(resp);
          this.standards = ccStandards;
        })
        .catch(() => {
          this.addErrorMessage("Error adding standards");
        });
    },
    linkTopicMaterial(materials) {

      const materialIds = materials.map(m => m.materials.id);
      const params = {
        topicId: this.topic.id,
        materialIds: materialIds
      };
      const data = null;
      this.$axios
        .post("/resource-mgmt/materials/link-topic-with-materials", data, {
          params,
          paramsSerializer: params => {
            return Qs.stringify(params, { arrayFormat: "repeat" });
          }
        })
        .then( (resp) => {
          const savedMaterialIds = resp.data.data;
          const savedMaterisl = materials.filter( m => savedMaterialIds.includes(m.materials.id));
         console.log(savedMaterisl)

          this.topicMaterials = [...this.topicMaterials, ...savedMaterisl];
        })
        .catch(error => {
          this.addErrorMessage(error.message);
        });
    },
    updatedTopic(topic) {
      const index = this.course.courseTopics.findIndex(
        ct => ct.topic.id == topic.id
      );
      if (index >= 0) {
        const courseTopic = this.course.courseTopics[index];
        courseTopic.topic = topic;
        this.course.courseTopics.splice(index, 1, courseTopic); //must run splice in order for Vue to trigger update to DOM
      }
    },
    initStandards() {
      const topicStandards = this.courseTopic.topic["topic_topicStandard"];
      if (topicStandards && topicStandards.length > 0) {
        this.standards = topicStandards.map(ts => ts.standard);
      } else {
        this.standards = [];
      }
    },
    initMaterials(){
    console.log('init materials')
      const topicMaterials = this.courseTopic.topic["topic_topicMaterials"];
        console.log(this.courseTopic.topic["topic_topicMaterials"])
      if(topicMaterials && topicMaterials.length > 0){
        this.topicMaterials = topicMaterials;
      }
      else{
        this.topicMaterials = [];
      }
    },
    unlinkTopicMaterial(topic, material){
      console.log('unlink topic material')
      console.log(topic);
      console.log(material);
      const params = {
        topicId: topic.id,
        materialIds: material.id
      }
      this.$axios.post('/resource-mgmt/materials/unlink-topic-from-materials', null, {params})
        .then( () => {
          const index = this.topicMaterials.findIndex( tm => tm.materials.id == material.id)
          this.topicMaterials.splice(index, 1);
        })
        .catch( () => {
          this.addErrorMessage('Error unlinking material from topic');
        })
    },
    uploadedMaterials(newMaterials){
      console.log(newMaterials);
      if(newMaterials){
        const courseMaterials = newMaterials.map(m => { return {materials: m} })
        this.linkTopicMaterial(courseMaterials);
      }
    }
  }
};
</script>